define('expose-editor', function(require, exports, module) {
    return module.exports = kityminder.Editor = require('./editor');
});



// WEBPACK FOOTER //
// ./src/kityminder-editor/expose-editor.js